import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import InvoiceDetails5 from "../invoiceDetails/InvoiceDetails5";
import { serviceTableStyle as commonTextStyle } from "./ServiceTableStyles";
import { InvoiceDataType } from "../../../api/invoice";

const ServiceTable: React.FC<{ data?: InvoiceDataType }> = ({ data }) => {
  // Calculate the Pre-Tax Total
  const preTaxTotal = data?.service?.preTaxAmount ?? 0;

  // Calculate SGST (9%) and CGST (9%)
  const sgst = data?.service?.sgst ?? 0;
  const cgst = data?.service?.cgst ?? 0;
  const hsnSac = data?.service?.hsn ?? "";

  // Calculate IGST (18%) (assuming the rate is 18%)
  const igst = 0;

  // Calculate the total amount including taxes
  const totalAmount = preTaxTotal + sgst + cgst + igst;

  // Round the total amount to the nearest whole number
  const roundedTotal = Math.round(totalAmount);
  // Calculate the round off amount (difference between rounded total and exact total)
  const roundOff = data?.service?.roundOff ?? 0;

  // Grand Total = Rounded total + SGST + CGST + IGST + RoundOff
  const grandTotal = roundedTotal + sgst + cgst + igst + roundOff;

  // Assuming we have a payment made 1500, the outstanding value will be:
  const paymentMade = 0;
  const outstandingValue = grandTotal - paymentMade;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow sx={{ borderBottom: "3px solid black" }}>
            <TableCell
              sx={{
                ...commonTextStyle.tableHead,
                width: "50%",
                borderRight: "3px solid black",
                textAlign: "center",
              }}
            >
              Item
            </TableCell>
            <TableCell
              sx={{
                ...commonTextStyle.tableHead,
                width: "25%",
              }}
            >
              HSN/SAC
            </TableCell>
            <TableCell
              sx={{
                ...commonTextStyle.tableHead,
                width: "25%",
                borderLeft: "3px solid black",
              }}
            >
              Pre Tax Amount (Rs.)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {serviceTaxData.map((data, index) => ( */}
          <TableRow>
            <TableCell
              sx={{
                ...commonTextStyle.serviceData,

                borderRight: "3px solid black",
                lineHeight: 2,
              }}
            >
              1. Service Fee Related to Training, Dispense Cleaning &
              Maintenance, Cold Chain Supply Logistics, Beer Dispense Rental &
              Glassware Rental
              {/* {index + 1}. {data.item} */}
            </TableCell>
            <TableCell
              sx={{
                ...commonTextStyle.serviceData,
              }}
            >
              {hsnSac}
            </TableCell>
            <TableCell
              sx={{
                ...commonTextStyle.serviceData,
                borderLeft: "3px solid black",
              }}
            >
              {data?.service?.preTaxAmount?.toLocaleString()}
            </TableCell>
          </TableRow>
          {/* ))} */}
          <TableRow
            sx={{
              borderTop: "3px solid black",
              borderBottom: "3px solid black",
            }}
          >
            <TableCell sx={{ verticalAlign: "top" }}>
              <div style={{ paddingLeft: "5px" }}>
                {" "}
                <InvoiceDetails5 showBankInfo data={data} />
              </div>
            </TableCell>
            <TableCell
              sx={{
                fontStyle: "italic",
                fontWeight: 500,
                borderRight: "3px solid black",
                borderLeft: "3px solid black",
                verticalAlign: "top",
              }}
            >
              <div style={{ paddingLeft: "5px" }}>
                <div
                  style={{
                    fontSize: "11px",
                    lineHeight: 2,
                    fontFamily: "Inter",
                  }}
                >
                  Pre-Tax Total (Rs.):
                </div>
                <div style={commonTextStyle.div}>SGST 9%:</div>
                <div style={commonTextStyle.div}>CGST 9%:</div>
                <div style={commonTextStyle.div}>IGST:</div>
                <div style={commonTextStyle.div}>Round Off:</div>
              </div>
              <div
                style={{
                  ...commonTextStyle.div,
                  marginTop: "20px",
                  paddingLeft: "5px",

                  fontWeight: 600,
                }}
              >
                Grand Total :{" "}
              </div>
            </TableCell>
            <TableCell
              sx={{
                verticalAlign: "top",
              }}
            >
              <div style={{ paddingLeft: "5px" }}>
                <div style={commonTextStyle.div}>
                  {preTaxTotal.toLocaleString()}
                </div>
                <div style={commonTextStyle.div}>{sgst.toLocaleString()}</div>
                <div style={commonTextStyle.div}>{cgst.toLocaleString()}</div>
                <div style={commonTextStyle.div}>{igst.toLocaleString()}</div>
                <div style={commonTextStyle.div}>{roundOff}</div>
                {/* {roundedTotal.toLocaleString()} */}
              </div>
              <div
                style={{
                  ...commonTextStyle.div,
                  marginTop: "20px",
                  paddingLeft: "5px",
                  borderTop: "3px solid black",

                  fontWeight: 600,
                }}
              >
                {" "}
                {data?.service?.grandTotal}{" "}
              </div>
            </TableCell>
          </TableRow>
          <TableRow sx={{ borderBottom: "3px solid black" }}>
            <TableCell
              colSpan={3}
              sx={{
                ...commonTextStyle.div,
                "&.MuiTableCell-root.MuiTableCell-root": {
                  paddingLeft: "3px",
                  fontFamily: "Inter",
                },
              }}
            >
              <span
                style={{
                  fontWeight: 500,
                  fontSize: "11px",
                  fontFamily: "Inter",
                }}
              >
                Amount in Words:{" "}
              </span>{" "}
              {data?.service?.amountInWords}
            </TableCell>
          </TableRow>
          <TableRow sx={{ borderBottom: "3px solid black" }}>
            <TableCell
              colSpan={3}
              sx={{
                ...commonTextStyle.div,
                "&.MuiTableCell-root.MuiTableCell-root": {
                  paddingLeft: "3px",
                  fontFamily: "Inter",
                },
              }}
            >
              <span
                style={{
                  fontWeight: 500,
                  fontSize: "11px",
                  fontFamily: "Inter",
                }}
              >
                Outstanding Amount:{" "}
              </span>{" "}
              {/* {outstandingValue} */}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ServiceTable;
